module.exports = __webpack_public_path__ + "img/P150T_weapon_126.c8ba2494.png";